export const BannerType = [
  {
    type: 0,
    name: "전체노출",
  },
  {
    type: 1,
    name: "최초아티스트선택",
  },
  {
    type: 2,
    name: "아티스트팔로우변경",
  },
  {
    type: 3,
    name: "HOT",
  },
];
